import Vue from 'vue'

export function systemSettingList() {
    return Vue.axios({
        url: '/api/systemSetting/list',
        method: 'get',
        params: {}
    })
}

export function systemSettingStore(data) {
    return Vue.axios({
        url: '/api/systemSetting/store',
        method: 'post',
        data: {...data}
    })
}

export function systemSettingValue(data) {
    return Vue.axios({
        url: '/api/systemSetting/keyValue',
        method: 'get',
        params: {...data}
    })
}

export function messageList(data) {
    return Vue.axios({
        url: '/api/message/list',
        method: 'get',
        params: {...data}
    })
}

export function messageToRead(data) {
    return Vue.axios({
        url: '/api/message/toRead',
        method: 'get',
        params: {...data}
    })
}

// export function dingDingAppId(data) {
//     return Vue.axios({
//         url: '/api/systemSet/dingDingAppId',
//         method: 'get',
//         params: {...data}
//     })
// }
